import { SvgProps } from "components/icons/types";

export const SmallCaretDownSolid = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="4"
    viewBox="0 0 6 4"
    fill="none"
    {...props}
  >
    <path d="M3 4L0 0H6L3 4Z" fill="currentColor" />
  </svg>
);
